<!--
外部リンク集
URL：externallink
-->

<template>
  <div>
    <v-container>
      <v-row justify="center">
        <v-list max-width="600">
          <v-list-item
              class="blue--text text-h5"
              title="気象庁（広島県  天気）"
          >
            <a
                href="https://www.data.jma.go.jp/gmd/cpd/monitor/dailyview/graph_mkhtml_d.php?n=47765"
                target="_blank"
                rel="noopener noreferrer"
                class="blue--text"
            >
              気象庁（広島県  天気）
            </a>
          </v-list-item>
          <v-list-item class="blue--text text-h5">
            <a
                href="https://www.pref.hiroshima.lg.jp/soshiki/32/links.html"
                target="_blank"
                rel="noopener noreferrer"
                class="blue--text"
            >
              広島県（水産海洋技術センター  地先水温）
            </a>
          </v-list-item>
          <v-list-item class="blue--text text-h5">
            <a
                href="https://www1.kaiho.mlit.go.jp/"
                target="_blank"
                rel="noopener noreferrer"
                class="blue--text"
            >
              海上保安庁（海洋情報部）
            </a>
          </v-list-item>
          <v-list-item class="blue--text text-h5">
            <a
                href="https://www.river.go.jp/index"
                target="_blank"
                rel="noopener noreferrer"
                class="blue--text"
            >
              国土交通省（川の防災情報）
            </a>
          </v-list-item>
        </v-list>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
